
/* injects from baggage-loader */

import loadTypes from 'utils/loadTypes'

export const SITES = loadTypes('SITES')
export const SITE_ADD = loadTypes('SITE_ADD')
export const SITE_DELETE = loadTypes('SITE_DELETE')
export const SITE_EDIT = loadTypes('SITE_EDIT')

function processSites(state, response) {
  if (!response || !response.length) return {}

  return response.reduce((acc, item) => ({...acc, [item.id]: item}), {})
}

function processEditedSite(sites, response) {
  if (!response || !response.length) return sites

  return {
    ...sites,
    [response.id]: response
  }
}

const initialState = {
  isFetching: false,
  list: null
}

export default function sites(state = initialState, action) {
  switch (action.type) {
    case SITES.REQUEST:
    case SITE_EDIT.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case SITES.SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: processSites(state, action.response)
      }

    case SITE_EDIT.SUCCESS:
      return {
        ...state,
        isFetching: false,
        list: processEditedSite(state.list, action.response)
      }

    case SITES.FAILURE:
    case SITE_EDIT.FAILURE:
      return {
        ...state,
        isFetching: false
      }

    case SITE_ADD.REQUEST:
      return {
        ...state,
        isFetching: true
      }

    case SITE_ADD.SUCCESS:
      return {
        ...state,
        isFetching: false
      }

    case SITE_ADD.FAILURE:
      return {
        ...state,
        isFetching: false
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/sites/index.js